import { FC, PropsWithChildren, ReactNode } from 'react';

export interface IFormBlock {
  title?: ReactNode,
  subTitle?: ReactNode,
  className?: string,
}

const FormBlock: FC<PropsWithChildren<IFormBlock>> = ({
  title,
  subTitle,
  children,
  className,
}) => (
  <div className={`grid py-6 px-4 gap-x-8 gap-y-10 pb-12 md:grid-cols-7 border-[1px] my-4 ${className || ''}`}>
    <div className="md:col-span-2 max-w-xl pl-4">
      {!!title && (
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          {title}
        </h2>
      )}
      {!!subTitle && (
        <p className="mt-1 text-sm leading-6 text-gray-600">
          {subTitle}
        </p>
      )}        
    </div>

    <div className="grid max-w-5xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12 md:col-span-5 pr-4">
      {children}
    </div>
  </div>
);


export default FormBlock;
